/**
 * IndexedDB schema for visit forms using Dexie
 * 
 * Stores VisitFormDraft and media files locally for offline support
 */
import Dexie, { type Table } from 'dexie';
import type { VisitFormDraft } from '@ox/ox-brokerage-client';

/**
 * Stored draft - just VisitFormDraft with auto-increment ID
 */
export interface StoredDraft extends VisitFormDraft {
  _id?: number; // Auto-increment primary key for IndexedDB
}

/**
 * Visit Forms Database
 * Manages local storage for visit form drafts and media files
 */
class VisitFormsDB extends Dexie {
  drafts!: Table<StoredDraft, number>;

  constructor() {
    super('VisitFormsDB');
    
    // Define schema version 1
    this.version(1).stores({
      drafts: '++_id, id, updatedAt',
    });
  }
}

// Create and export singleton instance
export const db = new VisitFormsDB();
